import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import * as fromGameHistory from '@fantaz/game-history/data-access';
import * as fromTournamentsV2 from '@fantaz/tournaments-v2/data-access';
import * as fromGames from '@fantaz/games/data-access';
import { GamesFacade } from '@fantaz/games/data-access';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AdvertisementEffects } from './+state/advertisement/advertisement.effects';
import * as fromAdvertisement from './+state/advertisement/advertisement.reducer';
import { CasualTournamentDetailsEffects } from './+state/casual-tournament-details/casual-tournament-details.effects';
import { CasualTournamentDetailsFacade } from './+state/casual-tournament-details/casual-tournament-details.facade';
import * as fromCasualTournamentDetails from './+state/casual-tournament-details/casual-tournament-details.reducer';
import { CasualTournamentEffects } from './+state/casual-tournament/casual-tournament.effects';
import * as fromCasualTournament from './+state/casual-tournament/casual-tournament.reducer';
import { GameOverEffects } from './+state/game-over/game-over.effects';
import * as fromGameOver from './+state/game-over/game-over.reducer';
import { LeaderBoardEffects } from './+state/leader-board/leader-board.effects';
import * as fromLeaderBoard from './+state/leader-board/leader-board.reducer';
import * as fromPasses from './+state/passes/passes.reducer';
import { PassesEffects } from './+state/passes/passes.effects';
import { PassesFacade } from './+state';
import * as fromPlayTournament from './+state/play-tournament/play-tournament.reducer';
import { PlayTournamentEffects } from './+state/play-tournament/play-tournament.effects';

@NgModule({
  imports: [
    CommonModule,
    //
    StoreModule.forFeature(fromGames.GAMES_FEATURE_KEY, fromGames.gamesReducer),
    EffectsModule.forFeature([fromGames.GamesEffects]),
    //
    StoreModule.forFeature(
      fromTournamentsV2.TOURNAMENTS_FEATURE_KEY,
      fromTournamentsV2.tournamentsReducer,
    ),
    EffectsModule.forFeature([fromTournamentsV2.TournamentsEffects]),
    //
    StoreModule.forFeature(
      fromCasualTournament.CASUAL_TOURNAMENT_FEATURE_KEY,
      fromCasualTournament.casualTournamentReducer,
    ),
    EffectsModule.forFeature([CasualTournamentEffects]),
    //
    StoreModule.forFeature(
      fromCasualTournamentDetails.CASUAL_TOURNAMENT_DETAILS_FEATURE_KEY,
      fromCasualTournamentDetails.casualTournamentDetailsReducer,
    ),
    EffectsModule.forFeature([CasualTournamentDetailsEffects]),
    //
    StoreModule.forFeature(
      fromGameHistory.GAME_HISTORY_FEATURE_KEY,
      fromGameHistory.gameHistoryReducer,
    ),
    EffectsModule.forFeature([fromGameHistory.GameHistoryEffects]),
    //
    StoreModule.forFeature(
      fromLeaderBoard.LEADER_BOARD_FEATURE_KEY,
      fromLeaderBoard.leaderBoardReducer,
    ),
    EffectsModule.forFeature([LeaderBoardEffects]),
    //
    StoreModule.forFeature(
      fromAdvertisement.ADVERTISEMENT_FEATURE_KEY,
      fromAdvertisement.advertisementReducer,
    ),
    EffectsModule.forFeature([AdvertisementEffects]),
    //
    StoreModule.forFeature(
      fromGameOver.GAME_OVER_FEATURE_KEY,
      fromGameOver.gameOverReducer,
    ),
    EffectsModule.forFeature([GameOverEffects]),
    //
    StoreModule.forFeature(fromPasses.PASSES_FEATURE_KEY, fromPasses.reducer),
    EffectsModule.forFeature([PassesEffects]),
    StoreModule.forFeature(
      fromPlayTournament.PLAY_TOURNAMENT_FEATURE_KEY,
      fromPlayTournament.playTournamentReducer,
    ),
    EffectsModule.forFeature([PlayTournamentEffects]),
  ],
  providers: [
    CasualTournamentDetailsFacade,
    PassesFacade,
    GamesFacade,
    fromTournamentsV2.TournamentsFacade,
  ],
})
export class TournamentDataAccessModule {}
